import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { GeneralResMock } from '../types/general.type'
import { TemplateMock } from '../types/template.type'

type Props = {
  id?: string
  page?: number
  limit?: number
  query?: string
  intake_id?: string
}
export const useDocTemplate = ({ id, intake_id, limit = 10, page = 1, query }: Props = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['template_doc', { query, limit, page, intake_id }],
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<TemplateMock[]>>('document_templates?', {
        params: {
          ...(page && { 'page[number]': page }),
          ...(limit && { 'page[size]': limit }),
          ...(intake_id && { intake_id }),
          ...(query && { query })
        }
      })
      return data
    }
  })

  const { data: document, isLoading: documentIsLoading } = useQuery({
    queryKey: ['template_doc', { id }],
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<TemplateMock>>(`document_templates/${id}`)
      return data.data
    },
    enabled: !!id
  })

  const { mutateAsync: createDoc } = useMutation({
    mutationFn: async (formRec: any) => {
      const { data } = await AXIOS_INSTANCE.post<GeneralResMock<TemplateMock>>('document_templates', formRec, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template_doc'] })
      queryClient.invalidateQueries({ queryKey: ['intake_consent'] })
    }
  })

  const { mutateAsync: updateDoc } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      const { data } = await AXIOS_INSTANCE.patch<GeneralResMock<TemplateMock>>(`document_templates/${id}`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template_doc'] })
      queryClient.invalidateQueries({ queryKey: ['intake_consent'] })
    }
  })

  const { mutateAsync: deleteDoc } = useMutation({
    mutationFn: async (id: string) => {
      const { data } = await AXIOS_INSTANCE.delete<GeneralResMock<TemplateMock>>(`document_templates/${id}`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['template_doc'] })
    }
  })
  return {
    documents: data?.data,
    isLoading,
    pagination: data?.meta.pagination,
    documentIsLoading,
    document,
    createDoc,
    updateDoc,
    deleteDoc
  }
}
